import { render, staticRenderFns } from "./PaginaRiepiloghiContratti.vue?vue&type=template&id=bbefcbe8"
import script from "./PaginaRiepiloghiContratti.vue?vue&type=script&lang=js"
export * from "./PaginaRiepiloghiContratti.vue?vue&type=script&lang=js"
import style0 from "./PaginaRiepiloghiContratti.vue?vue&type=style&index=0&id=bbefcbe8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports